/*
A library to wrap noon API
*/
import apisauce, { DEFAULT_HEADERS } from "apisauce";
import Cookies from "universal-cookie";
import importsAPI from "./ImportService";
import userAPI from "./UserService";
import dashboardAPI from "./DashboardService";
import ordersAPI from "./OrdersService";
import productsAPI from "./ProductsService";
import statementsAPI from "./StatementsService";
import transferAPI from "./TransferService";
import reportsAPI from "./ReportsServices";
import inventoryAPI from "./InventoryService";
import stockRequestAPI from "./StockRequestService";
import disputesAPI from "./DisputesService";
import Helper from "../helper/Helper";

// Remove Content-Type header as in get requests it confuses the API and causes a json parsing error
delete DEFAULT_HEADERS["Content-Type"];

const cookies = new Cookies("");

let locale = Helper.getLocale();

const headers = {
  "Cache-Control": "no-cache",
  "Content-Type": "application/json",
  "X-Locale": locale,
  "X-Platform": "web"
};
const api = apisauce.create({
  // base URL is read from the "constructor"
  baseURL: "/",
  // here are some default headers
  headers: headers,
  // 10 second timeout...
  // ...however, it doesn't work on React Native because the `timeout`
  // property of `XMLHttpRequest` hasn't been implemented.  It is
  // arriving in RN 0.25 though!
  timeout: 55000
});

const create = () => {
  // Wrap api's addMonitor to allow the calling code to attach
  // additional monitors in the future.

  const addMonitor = api.addMonitor(response => {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.log(response);
    }
  });

  const user = userAPI(api);
  const dashboard = dashboardAPI(api);
  const orders = ordersAPI(api);
  const products = productsAPI(api);
  const statements = statementsAPI(api);
  const transfer = transferAPI(api);
  const reports = reportsAPI(api);

  const imports = importsAPI(api);
  const inventory = inventoryAPI(api);
  const stockRequest = stockRequestAPI(api);
  const disputes = disputesAPI(api);

  return {
    user,
    dashboard,
    orders,
    products,
    statements,
    transfer,
    reports,

    imports,
    inventory,
    stockRequest,
    disputes
  };
};

// let's return back our create method as the default.
export default {
  create,
  baseapi: api
};



// WEBPACK FOOTER //
// ./src/services/index.js